import { SET_MANUAL_ENTRY_ADD_DATA, CLEAR_MANUAL_ENTRY_EDIT_DATA, CLEAR_MANUAL_ENTRY_ADD_DATA } from '../actions/actionTypes';

import ManualEntryAdd from '../../models/ManualEntryAdd';

const initialState: ManualEntryAdd = { } as ManualEntryAdd;

export const addAwbsReducer = (state = initialState, action: any) => {

  switch (action.type) {

    case SET_MANUAL_ENTRY_ADD_DATA:
      return {
        ...state,
        isAddMode: action.data.isAddMode,
        driverData: { ...state.driverData,
                      driverId: action.data.driverData.driverId,
                      driverIdType: action.data.driverData.driverIdType,
                      name: action.data.driverData.name,
                      company: action.data.driverData.company,
                      truckPlateNumber: action.data.driverData.truckPlateNumber,
                      rfsNumber: action.data.driverData.rfsNumber,
                      driverTime: action.data.driverData.driverTime
                    },
        forwarderId: action.data.forwarderId,
        dockId:  action.data.dockId,
        orderNumber:  action.data.orderNumber,
        isInterline: action.data.isInterline,
        isRfs: action.data.isRfs,
        orderId: action.data.orderId
      }
    case CLEAR_MANUAL_ENTRY_ADD_DATA:
        return initialState;
    default:
      return state;
  }

};
